import { spanishPhonotactics } from "../phonotactics/spanishPhonotactics";
import { RuleSet } from "../rules/ruleSet";
import { aspirationRules } from "./accentRules";

/** Spanish IPA with a General American accent */
export const americanizedSpanish: RuleSet = {
  syllableBreaks: spanishPhonotactics,
  phonemeLengths: {
    map: {
      ɑ: 200, ɛ: 200, i: 200, ɪ: 160, ə: 150,
      e̞i̯: 200, ɤ̞o̯: 200, ɯu̯: 200,
      ɑɹ: 200, oɹ: 200, ɝ: 200,
    }
  },
  rules: [
    { from: 'ˈdon', to: 'ˈdan' },

    { from: 'β', to: 'v' }, // or /b/ if it was written that way
    { from: 'θ', to: 's' }, // or /z/ if it was written that way
    { from: 'ð̬', to: 'z' },
    { from: 'ð', to: 'd' },
    { from: 'ɣ', to: 'g' },
    { from: 'x', to: 'h' },
    { from: 'ʎ', to: 'l' },
    { from: 't', to: 'ᴅ', previous: ['vowel'], next: ['vowel'] },
    { from: 'ʝ', to: 'j' },

    // rhotics /ɾ|r/, /.ˈ/, /./, plain
    { from: 'a.ˈɾ', to: 'ɑɹ.ˈ' }, { from: 'a.ɾ', to: 'ɑɹ.' }, { from: 'aɾ', to: 'ɑɹ' },
    { from: 'a.ˈr', to: 'ɑɹ.ˈ' }, { from: 'a.r', to: 'ɑɹ.' }, { from: 'ar', to: 'ɑɹ' },
    { from: 'o.ˈɾ', to: 'oɹ.ˈ' }, { from: 'o.ɾ', to: 'oɹ.' }, { from: 'oɾ', to: 'oɹ' },
    { from: 'o.ˈr', to: 'oɹ.ˈ' }, { from: 'o.r', to: 'oɹ.' }, { from: 'or', to: 'oɹ' },
    { from: 'u.ˈɾ', to: 'ɝ.ˈ' }, { from: 'u.ɾ', to: 'ɝ.' }, { from: 'uɾ', to: 'ɝ' },
    { from: 'u.ˈr', to: 'ɝ.ˈ' }, { from: 'u.r', to: 'ɝ.' }, { from: 'ur', to: 'ɝ' },
    { from: 'r', to: 'ɹ' }, { from: 'ɾ', to: 'ɹ' },

    // a
    { from: 'a', to: 'ə', next: ['#word'], syllable: { current: 'unstressed' } }, { from: 'aˑ', to: 'ə', syllable: { current: 'unstressed' } },
    { from: 'a.a', to: 'ə', syllable: { current: 'unstressed', next: ['unstressed'] } },
    { from: 'a', to: 'ə', syllable: { current: 'unstressed' } },
    { from: 'a', to: 'ɑ' },
    // e
    { from: 'es', to: 'iz', next: ['#word'], syllable: { current: 'unstressed' } },
    { from: 'e', to: 'e̞i̯', next: ['#word'] },
    { from: 'e', to: 'ə', syllable: { current: 'unstressed' } },
    { from: 'e', to: 'ɛ' }, { from: 'eˑ', to: 'ɛ' },
    // i
    { from: 'i', to: 'ɪ', syllable: { current: 'unstressed' } },
    // o
    { from: 'o', to: 'ɤ̞o̯' },
    // u
    { from: 'u', to: 'ɯu̯' },

    ...aspirationRules,
  ],
};
